import { Injectable } from '@angular/core';
import { WeappsServices } from '../api/weapps';
import type { paths as ALTAIR_PATHS } from '../api/weapps/altair2'
import { fetchAuthSession } from 'aws-amplify/auth';

export type UserData = ALTAIR_PATHS["/user/{userId}"]["get"]["responses"][200]["content"]['application/json'];

@Injectable({
  providedIn: 'root'
})
export class NewUserService {

  async getMultipleUsers(userIds: string[]): Promise<UserData[]> {
    try {
      const api = await WeappsServices.altair();
      const response = await api.POST('/users', {
        body: {
          userIds: userIds
        }
      });
      if (response.response.status !== 200 || !response.data) {
        throw new Error(`Failed to fetch users data: ${response.response.statusText}`);
      } else {
        return response.data;
      }
    } catch (e) {
      console.error(`Error fetching multiple users:`, e);
      return [];
    }
  }

  public async loadUserFromToken() {
    try {
      // Fetch the current auth session
      const session = await fetchAuthSession();

      // Extract the ID token
      const idToken = session.tokens?.idToken?.toString();
      if (!idToken) {
        throw new Error('Could not extract ID token.');
      }

      // Decode the token payload
      const decoded = JSON.parse(atob(idToken.split('.')[1]));

      // Extract attributes based on UserProfile interface
      const profile = {
        id: decoded['userId'],                 // Custom claim user ID
        sub: decoded['sub'],                   // Cognito user ID (sub)
        name: decoded['userName'] || '',       // Custom claim for user name
        email: decoded['email'],               // Email attribute
        avatar: decoded['avatar'] || '',       // Custom claim for avatar
        groups: decoded['cognito:groups'] || [], // Cognito groups
      };

      return profile;
      // this.store.dispatch(UserActions.userProfileLoaded({up:profile}));
    } catch (error) {
      console.log(`Could not extract extract user data from the token or renew subscriptions => ${error}`);
      return null;
    }
  }
}